/**
 * i18n.ts — react-i18next configuration for The Inner Awakening.
 *
 * Supported locales: en (English), pl (Polish — first additional language).
 * Language preference is stored on the user's profile (profiles.language)
 * and loaded via useLanguage() hook on app mount.
 *
 * Translation files live in public/locales/{lang}/translation.json.
 * These are loaded via i18next-http-backend so they can be deployed
 * independently and don't bloat the initial bundle.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Supported languages
    supportedLngs: ['en', 'pl'],
    fallbackLng: 'en',
    defaultNS: 'translation',

    // Load from public/locales/{lng}/{ns}.json
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Detection order: profile preference is set via i18n.changeLanguage()
    // on auth — browser detector is the fallback for unauthenticated screens.
    //
    // `?lang=` comes first because an auth email lands on this app carrying
    // the language it was written in (see src/pages/Login.tsx). Without it,
    // a Polish sign-in email could open an English app on a device that has
    // never stored a preference. useLanguage() still overrides from the
    // profile once the session resolves, so a stored preference wins.
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
      lookupLocalStorage: 'ia_language',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    // Don't suspend the app — components must handle loading state
    react: {
      useSuspense: false,
    },
  })

export default i18n
